import type { FieldSetter, ModeForm } from "./types";
import { TF } from "./TF";
import { FieldErrorText } from "./FormField";

// Input ids are the validator's keys ("modeOfTransaction.swipedPct"), which
// is what scroll-to-first-error and the blur tracking both resolve against.
//
// The running total lives in the enclosing Section's `aside` slot, not here,
// so it reads top-right of the heading instead of trailing the inputs.
// Callers pass <PercentageTotalIndicator total={modeTotal} />.
export function TransactionMixFields({
  mode,
  setModeField,
  fieldError,
  required,
}: {
  mode: ModeForm;
  setModeField: FieldSetter<ModeForm>;
  fieldError: (field: string) => string | undefined;
  required: boolean;
}) {
  const groupError = fieldError("modeOfTransaction");
  return (
    <>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
        <TF
          id="modeOfTransaction.swipedPct"
          label="Swiped %"
          value={mode.swipedPct}
          onChange={(v) => setModeField("swipedPct", v)}
          format="integer"
          maxLength={3}
          required={required}
          error={fieldError("modeOfTransaction.swipedPct")}
        />
        <TF
          id="modeOfTransaction.keyedPct"
          label="Keyed %"
          value={mode.keyedPct}
          onChange={(v) => setModeField("keyedPct", v)}
          format="integer"
          maxLength={3}
          required={required}
          error={fieldError("modeOfTransaction.keyedPct")}
        />
        <TF
          id="modeOfTransaction.eCommercePct"
          label="eCommerce %"
          value={mode.eCommercePct}
          onChange={(v) => setModeField("eCommercePct", v)}
          format="integer"
          maxLength={3}
          required={required}
          error={fieldError("modeOfTransaction.eCommercePct")}
        />
        <TF
          id="modeOfTransaction.mailOrderPct"
          label="Mail/phone %"
          value={mode.mailOrderPct}
          onChange={(v) => setModeField("mailOrderPct", v)}
          format="integer"
          maxLength={3}
          required={required}
          error={fieldError("modeOfTransaction.mailOrderPct")}
        />
      </div>
      {/* The "must total 100" rule belongs to the group, not to any one
          input, so it gets its own focus target for scroll-to-first-error. */}
      <div id="modeOfTransaction" tabIndex={-1}>
        {groupError && (
          <FieldErrorText id="modeOfTransaction-err" className="!mt-0">
            {groupError}
          </FieldErrorText>
        )}
      </div>
    </>
  );
}
